import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FileText, Clock, Calendar, ArrowRight, User } from 'lucide-react';

const articlePaths: Record<string, string> = {
  pt: '/artigo/',
  en: '/article/',
  de: '/artikel/',
};

export default function ArticlePreview() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const currentLang = i18n.language || 'pt';

  return (
    <section className="py-14 md:py-20 bg-warm-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-xl bg-brand-50 flex items-center justify-center">
            <FileText className="w-5 h-5 text-brand-600" />
          </div>
          <h2 className="font-display text-xl md:text-2xl font-bold text-warm-900">{t('latestGuide')}</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 items-start">
          <div className="group rounded-2xl border border-warm-200 bg-white overflow-hidden hover:border-brand-300 transition-all duration-200 cursor-pointer"
            onClick={() => navigate(articlePaths[currentLang] || '/artigo/')}
          >
            <div className="relative aspect-[16/9] bg-warm-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimal%20workspace%20with%20a%20laptop%20showing%20a%20colorful%20product%20spreadsheet%2C%20clean%20white%20desk%2C%20small%20potted%20plant%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20editorial%20photography&width=800&height=450&seq=article-preview-2026&orientation=landscape&nocache=true"
                alt="Article preview"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
            </div>
            <div className="p-5 md:p-6">
              <div className="flex items-center gap-3 text-xs text-warm-500 mb-3">
                <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {t('published')}</span>
                <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {t('readingTime')}</span>
                <span className="flex items-center gap-1"><User className="w-3.5 h-3.5" /> {t('author')}</span>
              </div>
              <h3 className="font-display text-lg md:text-xl font-bold text-warm-900 mb-2 group-hover:text-brand-700 transition-colors">{t('articleTitle')}</h3>
              <p className="text-sm text-warm-500 leading-relaxed mb-4">{t('articleMetaDesc')}</p>
              <div className="flex items-center gap-2 text-sm font-medium text-brand-700 group-hover:text-brand-800 transition-colors">
                {t('readGuide')} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <div className="p-5 rounded-xl border border-warm-200 bg-white hover:border-brand-300 hover:bg-brand-50 transition-all cursor-pointer"
              onClick={() => navigate(articlePaths[currentLang] || '/artigo/')}
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h4 className="font-medium text-warm-800 mb-1">{t('relatedArticle1')}</h4>
                  <p className="text-xs text-warm-500">{t('readingTime')}</p>
                </div>
                <ArrowRight className="w-4 h-4 text-warm-400 flex-shrink-0 mt-1" />
              </div>
            </div>
            <div className="p-5 rounded-xl border border-warm-200 bg-white hover:border-brand-300 hover:bg-brand-50 transition-all cursor-pointer"
              onClick={() => navigate(articlePaths[currentLang] || '/artigo/')}
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h4 className="font-medium text-warm-800 mb-1">{t('relatedArticle2')}</h4>
                  <p className="text-xs text-warm-500">{t('readingTime')}</p>
                </div>
                <ArrowRight className="w-4 h-4 text-warm-400 flex-shrink-0 mt-1" />
              </div>
            </div>
            <div className="p-5 rounded-xl border border-warm-200 bg-white hover:border-brand-300 hover:bg-brand-50 transition-all cursor-pointer"
              onClick={() => navigate(articlePaths[currentLang] || '/artigo/')}
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h4 className="font-medium text-warm-800 mb-1">{t('relatedArticle3')}</h4>
                  <p className="text-xs text-warm-500">{t('readingTime')}</p>
                </div>
                <ArrowRight className="w-4 h-4 text-warm-400 flex-shrink-0 mt-1" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}